<template>
  <Navbar></Navbar>
  <Banner />
  <div class="content-wrapper">
    <div class="main-content">
      <WishlistContent />
    </div>
    <FooterItem />
  </div>
</template>

<script>
import Navbar from "@/components/Layout/Navbar.vue";
import WishlistContent from "@/components/Wishlist/WishlistContent.vue";
import FooterItem from "@/components/Layout/FooterItem.vue";
import { useHead } from "@vueuse/head";
import { mapGetters } from "vuex";
import store from "@/store";
export default {
  components: {
    Navbar,
    WishlistContent,
    FooterItem,
  },
  computed: {
    ...mapGetters(["currentLanguage"]),
  },
  methods: {
    updateHeadMeta() {
      const title =
        this.currentLanguage === "ar"
          ? "قائمة الرغبات - Planning Force | احفظ الدورات المفضلة لديك لتتعلمها لاحقًا"
          : "Wishlist - Planning Force | Save Your Favorite Courses to Learn Later";

      const description =
        this.currentLanguage === "ar"
          ? "اكتشف الدورات التدريبية المفضلة لديك واحفظها في قائمة الرغبات لتتمكن من الوصول إليها وتعلمها في الوقت الذي يناسبك."
          : "Discover your favorite courses and save them to your wishlist so you can access and learn them at your convenience.";

      const keywords =
        this.currentLanguage === "ar"
          ? "قائمة الرغبات, دورات تدريبية, تعليم إلكتروني, تعلم, Planning Force"
          : "wishlist, favorite courses, e-learning, learning, Planning Force";

      useHead({
        title: title,
        meta: [
          { name: "description", content: description },
          { name: "keywords", content: keywords },
          { name: "robots", content: "index, follow" },
          {
            name: "author",
            content:
              this.currentLanguage === "ar"
                ? "Planning Force"
                : "Planning Force",
          },
          {
            name: "language",
            content: this.currentLanguage === "ar" ? "ar" : "en",
          },

          // Open Graph meta tags
          { property: "og:title", content: title },
          { property: "og:description", content: description },
          {
            property: "og:image",
            content: "https://example.com/wishlist-image.jpg",
          }, // Replace with your wishlist page image URL
          { property: "og:url", content: "https://example.com/wishlist" }, // Replace with your wishlist page URL
          { property: "og:type", content: "website" },

          // Twitter Card meta tags
          { name: "twitter:card", content: "summary_large_image" },
          { name: "twitter:title", content: title },
          { name: "twitter:description", content: description },
          {
            name: "twitter:image",
            content: "https://example.com/wishlist-image.jpg",
          }, // Replace with your wishlist page image URL
        ],
      });
    },
  },
  mounted() {
    this.updateHeadMeta();
  },
  watch: {
    currentLanguage: {
      handler(newLang, oldLang) {
        //  this.language = newLang;
        this.updateHeadMeta();
        store.dispatch("categoriesList");
      },
      immediate: true, // Run the handler immediately when the component is mounted
    },
  },
};
</script>
